import { useState, useEffect } from 'react';
import { Router } from '@reach/router';
import { AppPath } from 'appConstants';
import { Dashboard } from 'pages/dashboard/Dashboard';
import { NewSubscription } from 'pages/newSubscription/NewSubscription';
import { Profile } from 'pages/profile/Profile';
import { ManageUsers } from 'pages/manageUsers/ManageUsers';
import { ManageSchool } from 'pages/manageSchool/ManageSchool';
import { Invoices } from 'pages/invoices/Invoices';
import { SignIn } from 'pages/SignIn';
import { ForgottenPassword } from 'pages/ForgottenPassword';
import { ResetPassword } from 'pages/ResetPassword';
import { Subscribe } from 'pages/subscribe/Subscribe';
import { Subscriptions } from 'pages/subscriptions/Subscriptions';
import { useDispatch, useSelector } from 'react-redux';
import { checkSignedIn, selectAppVisible } from 'reducers/auth';
import { selectAccessibilityMode } from 'reducers/misc';
import Toast from 'components/toast/Toast';
import InvoicePage from 'pages/invoices/InvoicePage';
import UpgradeFreeSubscriptions from 'pages/upgradeSubscription/UpgradeFreeSubscriptions';
import SubscribeFreeTrial from 'pages/subscribeFreeTrial/SubscribeFreeTrial';
import { SetPassword } from 'pages/SetPassword';
import NotFound from 'pages/NotFound';
import ErrorBoundary from 'components/errorBoundary/ErrorBoundary';
import ErrorFallback from 'components/errorFallback/ErrorFallback';
import AddFreeTrial from 'pages/addFreeTrial/AddFreeTrial';
import { BlockCopyandPaste } from 'helpers/blockCopyandPaste';
import CookieBanner from './components/shared/CookieBanner';
import Cookies from 'universal-cookie';

const App = () => {
  const dispatch = useDispatch();
  const accessibilityMode = useSelector(selectAccessibilityMode);
  const [cookieSettingsSelection, setCookieSettingsSelection] = useState<string>('');

  dispatch(checkSignedIn());
  const showApp = useSelector(selectAppVisible);

  useEffect(() => {
    BlockCopyandPaste();
  }, []);

  useEffect(() => {
    let cookieSettingFlag = new Cookies();
    setCookieSettingsSelection(cookieSettingFlag.get('cookie_settings') ? cookieSettingFlag.get('cookie_settings') : "");
  }, []);

  if (!showApp) {
    return null;
  }

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <div className={'App' + (accessibilityMode ? ' accessible' : '')}>
        <Router>
          {[AppPath.SIGN_IN, AppPath.ROOT].map((path: string, i: number) => (
            <SignIn path={path} key={i} />
          ))}
          <SignIn path={AppPath.SIGN_IN} />
          <ForgottenPassword path={AppPath.FORGOTTEN_PASSWORD} />
          <ResetPassword path={AppPath.RESET_PASSWORD} />
          <SetPassword path={AppPath.SET_PASSWORD} />
          <Subscribe path={AppPath.SUBSCRIBE} />
          <SubscribeFreeTrial path={AppPath.SUBSCRIBE_FREE_TRIAL} />
          <Dashboard path={AppPath.DASHBOARD} />
          <Subscriptions path={AppPath.SUBSCRIPTIONS} />
          <NewSubscription path={AppPath.NEW_SUBSCRIPTION} />
          <AddFreeTrial path={AppPath.NEW_FREE_TRIAL} />
          <UpgradeFreeSubscriptions path={AppPath.UPGRADE_SUBSCRIPTION} />
          <Profile path={AppPath.PROFILE} />
          <ManageUsers path={AppPath.MANAGEUSERS} />
          <ManageSchool path={AppPath.MANAGESCHOOL} />
          <Invoices path={AppPath.INVOICES} />
          <InvoicePage path={AppPath.INVOICE_PAGE} />
          <NotFound default />
        </Router>
        <Toast />
        {!cookieSettingsSelection && <CookieBanner />}
      </div>
    </ErrorBoundary>
  );
};

export default App;
